import _regeneratorRuntime from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.json.stringify.js";
import KivaProxy from "@/utils/kivaProxy/src";
import { FieldOptionTransformer } from "@/transformers/FieldOptionTransformer";
import { Base64 } from 'js-base64';
import { makeNest } from "@/utils/makeNest";
import { InboxCategoryTransformer } from "@/transformers/InboxCategoryTransformer";
export default {
  computed: {
    options: function options() {
      return this.$store.state.app.optionsList;
    }
  },
  methods: {
    getStoreName: function getStoreName(app, model, column) {
      var isLocale = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var locale = this.$locale ? this.$locale : 'en';
      if (isLocale) {
        return app + "_" + model + "_" + column + '_' + locale;
      } else {
        return app + "_" + model + "_" + column;
      }
    },
    getOptionsData: function getOptionsData(params) {
      var app = params.app;
      var model = params.model;
      var column = params.column;
      var storeName = this.getStoreName(app, model, column);
      if (this.options[storeName]) {
        return this.options[storeName];
      }
    },
    getInboxCategory: function getInboxCategory(params) {
      var _arguments = arguments,
        _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var force, app, model, column, max, storeName, storeNameLocale, endpoint, storage, dataStored, oldData, diff;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              force = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : false;
              app = 'inbox';
              model = 'category';
              column = 'all';
              max = params.max ? params.max : 300;
              storeName = _this.getStoreName(app, model, column);
              storeNameLocale = _this.getStoreName(app, model, column, true); // for locale storege
              endpoint = app + "/" + model;
              storage = localStorage.getItem(storeNameLocale);
              dataStored = false; // console.log(   " q JSON.parse(Base64.decode(oldData.options))",oldData.options)
              if (force != true && storage && storage.charAt(0) == '{') {
                oldData = JSON.parse(storage);
                diff = (new Date().getTime() - oldData.time) / 1000;
                if (diff < max && diff > 0) {
                  dataStored = true;
                  _this.options[storeName] = JSON.parse(Base64.decode(oldData.options));
                }
              }
              if (dataStored == false) {
                new KivaProxy({
                  endpoint: endpoint
                }).all().then(function (response) {
                  var res = makeNest(InboxCategoryTransformer.fetchCollection(response.records), {
                    parentKey: "parentCategory",
                    elementKey: "recordId"
                  });
                  _this.options[storeName] = res;
                  var spData = {
                    time: new Date().getTime(),
                    options: Base64.encode(JSON.stringify(res))
                  };
                  localStorage.setItem(storeNameLocale, JSON.stringify(spData));
                });
              }
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    getOptions: function getOptions(params) {
      var _arguments2 = arguments,
        _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var force, app, model, column, max, storeName, storeNameLocale, endpoint, storage, dataStored, oldData, diff, _endpoint, _storage, filters, ids, _dataStored, _oldData, _diff, bs;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              force = _arguments2.length > 1 && _arguments2[1] !== undefined ? _arguments2[1] : false;
              app = params.app;
              model = params.model;
              column = params.column;
              max = params.max ? params.max : 300;
              storeName = _this2.getStoreName(app, model, column);
              storeNameLocale = _this2.getStoreName(app, model, column, true); // for locale storege
              if (!(force != true && _this2.options[storeName] && _this2.options[storeName][0] && _this2.options[storeName][0] != "")) {
                _context2.next = 10;
                break;
              }
              _context2.next = 31;
              break;
            case 10:
              if (!(column != "all")) {
                _context2.next = 20;
                break;
              }
              endpoint = app + "/" + model + "/" + column + "/options";
              storage = localStorage.getItem(storeNameLocale);
              dataStored = false;
              if (force != true && storage && storage.charAt(0) == '{') {
                oldData = JSON.parse(storage);
                diff = (new Date().getTime() - oldData.time) / 1000;
                if (diff < max && diff > 0) {
                  dataStored = true;
                  // console.log(   " 104  ",oldData.options)
                  _this2.options[storeName] = JSON.parse(Base64.decode(oldData.options));
                }
              }
              // console.log("dataStored",dataStored,storeName);
              if (!(dataStored == false)) {
                _context2.next = 18;
                break;
              }
              _context2.next = 18;
              return new KivaProxy({
                endpoint: endpoint
              }).all().then(function (response) {
                var res = FieldOptionTransformer.fetchCollection(response.records);
                _this2.options[storeName] = res;
                var spData = {
                  time: new Date().getTime(),
                  options: Base64.encode(JSON.stringify(res))
                };
                localStorage.setItem(storeNameLocale, JSON.stringify(spData));
              });
            case 18:
              _context2.next = 31;
              break;
            case 20:
              if (!(column == "all")) {
                _context2.next = 31;
                break;
              }
              _endpoint = app + "/" + model;
              _storage = localStorage.getItem(storeNameLocale);
              filters = params.filters ? params.filters : {};
              ids = params.ids ? params.ids : null;
              if (ids) {
                _endpoint = _endpoint + "/" + ids;
              }
              _dataStored = false;
              if (force != true && _storage && _storage.charAt(0) == '{') {
                _oldData = JSON.parse(_storage);
                _diff = (new Date().getTime() - _oldData.time) / 1000; // console.log(   " 132 JSON.parse(Base64.decode(oldData.options))",oldData.options)
                if (_diff < max && _diff > 0) {
                  _dataStored = true;
                  bs = Base64.decode(_oldData.options);
                  if (bs && bs.charAt(0) == '{') {
                    _this2.options[storeName] = JSON.parse(bs);
                  }
                }
              }
              if (!(_dataStored == false)) {
                _context2.next = 31;
                break;
              }
              _context2.next = 31;
              return new KivaProxy({
                endpoint: _endpoint
              }).setFilters(filters).all().then(function (response) {
                var res = response.records;
                _this2.options[storeName] = res;
                var spData = {
                  time: new Date().getTime(),
                  options: Base64.encode(JSON.stringify(res))
                };
                localStorage.setItem(storeNameLocale, JSON.stringify(spData));
              });
            case 31:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
  }
};